import { FormArray, FormControl, FormGroup } from '@angular/forms';
// import { Subject } from 'rxjs';

export class Presenter<T> {
    /**
     * Form  of presenter
     */
    protected form: FormGroup;
    // /**
    //  * Unsubscribe  of presenter
    //  */
    // protected unsubscribe: Subject<void>;
    /**
     * Creates an instance of presenter.
     */
    public constructor() {
        // this.unsubscribe = new Subject();
    }
    /**
     * Gets form
     */
    public get Form() {
        return this.form;
    }
    /**
     * Gets value
     */
    public get Value(): T {
        return this.form.value as T;
    }
    /**
     * Gets raw value
     */
    public get RawValue(): T {
        return this.form.getRawValue();
    }
    /**
     * Gets invalid
     */
    public get Invalid(): boolean {
        return this.form.invalid;
    }
    /**
     * Patchs value
     * @param model T
     * @param [options] { emitEvent?: boolean; onlySelf?: boolean; }
     */
    public patchValue(
        model: T,
        options?: {
            emitEvent?: boolean;
            onlySelf?: boolean;
        }
    ): void {
        this.form.patchValue(model, options);
    }
    /**
     * Gets valid
     */
    public get Valid(): boolean {
        return this.form.valid;
    }
    /**
     * Disabled presenter
     */
    public Disabled(): void {
        this.form.disable();
    }
    /**
     * Disabled presenter
     */
    public Enabled(): void {
        this.form.enable();
    }
    /**
     * Marks all as touched
     */
    public markAllAsTouched() {
        this.markFormGroupTouched(this.Form);
    }
    /**
     * Marks form group touched
     * @param formGroup FormGroup | FormArray
     */
    private markFormGroupTouched(formGroup: FormGroup | FormArray): void {
        Object.keys(formGroup.controls).forEach((key: string) => {
            const control: FormGroup | FormArray | FormControl = formGroup.get(
                key
            ) as FormGroup | FormArray | FormControl;

            // tslint:disable-next-line:no-string-literal
            if (!control['controls']) {
                control.markAsDirty();
                control.markAllAsTouched();
            } else {
                this.markFormGroupTouched(control as FormGroup | FormArray);
            }
        });
    }
}
